module.exports = __webpack_public_path__ + "static/media/astro_retail.b4ca53ae.png";